import { ProtectedSearchForm } from "./Components/ApplicantSearch";
import { ThreeColumnPage } from "./Components/ThreeColumnPage";

export function ProtectedSearchPage(props: {}) {
    return <ThreeColumnPage
        main={<div className="p-10">
            <ProtectedSearchForm closeModal={() => {}} />
        </div>}
    />
}